export default __webpack_public_path__ + "static/media/cashless-payment.f928bb22.png";